import { useMemo } from "react";
import { useRole } from "@hooks/useRole";
import { useIsMobile } from "@hooks/useIsMobile.jsx";
import { artistRoutes, recruiterRoutes } from "../router.routes.jsx";

export function useRoleRoutes() {
  const { selectedRole } = useRole();
  const isMobile = useIsMobile();

  return useMemo(
    () =>
      selectedRole === "agency"
        ? recruiterRoutes(isMobile)
        : artistRoutes(isMobile),
    [selectedRole, isMobile]
  );
}
